import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { Button, ContentSection, Icon, IconSize, Layout } from '@vwfs-bronson/bronson-react';
import { dashboardHomeNavigationListNew } from '../../../../resources/base/models';
import { KnownSearchParams } from '../../../../resources/base/models/enums';
import { removeSearchParamsFromUrl } from '../../../../services/common/miscUtils';
import { resetQuoteSpecificReduxData } from '../../../../services/redux';
import { clearSelectedComparisonOfferIds } from '../../../../services/redux/features/dashboard.slice';
import { loadingActions } from '../../../../services/redux/features/loading.slice';
import { useNavigate } from '../../../../services/routing/navigate';

export const DashboardSubpageHome: FunctionComponent = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!state?.navigatedFromHeader) {
      return;
    }

    dispatch(loadingActions.setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.navigatedFromHeader]);

  useEffect(() => {
    resetQuoteSpecificReduxData();
    removeSearchParamsFromUrl(KnownSearchParams.cid);
    dispatch(clearSelectedComparisonOfferIds());
  });

  return (
    <ContentSection pageWrap pageWrapSize="medium" className="u-mt u-mt-none@s u-pv-none@s">
      <Layout>
        <Layout.Item default="1/1">
          <Layout>
            {dashboardHomeNavigationListNew?.map(({ label, link, index, ...props }) => (
              <React.Fragment key={`${label}-${index}`}>
                <Layout.Item default="1/4" s="1/1">
                  <Button secondary full onClick={() => navigate.url(link)}>
                    <Layout className="o-layout--flush u-pt-small u-pb-small">
                      {'icon' in props && props.icon && (
                        <Layout.Item default="1/1">
                          <Icon name={props.icon} size={IconSize.XLARGE} />
                        </Layout.Item>
                      )}
                      <Layout.Item default="1/1">
                        <span>{label}</span>
                      </Layout.Item>
                    </Layout>
                  </Button>
                  {'subNavigations' in props &&
                    props.subNavigations.length > 0 &&
                    props.subNavigations.map((subNavigation) => {
                      const { label: subLabel, link: subLink, index: subIndex } = subNavigation;
                      return (
                        <div key={`${index}-${subIndex}`}>
                          <Button
                            small
                            simple
                            className="u-mt-small"
                            secondary
                            link
                            icon="semantic-forward"
                            onClick={() => {
                              subNavigation.onClick?.(dispatch);
                              navigate.url(subLink);
                            }}
                          >
                            {subLabel}
                          </Button>
                        </div>
                      );
                    })}
                </Layout.Item>
              </React.Fragment>
            ))}
          </Layout>
        </Layout.Item>
      </Layout>
    </ContentSection>
  );
};
